import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import DataTable from "../../../component/DataTable";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";
import AddProjectCat from "./AddProjectCat";
import EditProjectCat from "./EditProjectCat";

const categoryListEndpoint = ApiEndpoints.projectType.list;
const categoryDeleteEndpoint = ApiEndpoints.projectType.delete;
const tableHeader = ["Date", "Project Type", "status"];
const tbody = ["createdAt", "type", "status"];

export default function ProjectCat() {
  const [catId, setCatId] = useState("");
  const [modaleditShow, setModalEditShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", categoryListEndpoint);
      const result = response.project_types;
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (blogcategory_id) => {
    const payload = { blogcategory_id };
    try {
      const response = await ApiRequest("POST", categoryDeleteEndpoint, payload);
      toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.log(error);
    }
  };

  const pagename = {
    name: 'Project Management',
    user: 'Admin',
    innerpage: 'Project Management / Category'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" onClick={() => setModalShow(true)}> Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          setModalShow={setModalEditShow}
          setId={setCatId}
        // onDelete={handleDelete}
        />
      </div>
      <AddProjectCat show={modalShow} onHide={() => setModalShow(false)} />
      <EditProjectCat show={modaleditShow} catId={catId} onHide={() => setModalEditShow(false)} />
    </>
  );
}
